module.exports = __webpack_public_path__ + "static/media/zeya_first_word.5ca72e84.ogg";